const BUTTON_TYPE = ['Default', 'Primary', 'Secondary', 'Tertiary', 'Text', 'Link'];

export default {
    BUTTON_TYPE,
};
